import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { Config, loadConfig } from './config';
import { routing } from "./app.routing";
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard.component';
import { FooterComponent } from './footer.component';
import { LoginComponent } from './login.component';
import { AppTitle } from './shared/title';
import { AlertDirective } from './shared/alert.directive';
import { OffClickDirective } from "./shared/off_click.directive";
import { Account, accountServiceFactory } from './services/account.service';
import { IdentityService, IdentityServiceFactory } from './services/identity.service';
import { Auth } from './guard/auth';
import { Angulartics2Module } from 'angulartics2';
import { CatchAllComponent } from './catchall.component';
import { TruncatePipe } from './shared/truncate.pipe';
import { AppToggleComponent } from './shared/app_toggle.component';
import { FileUploadModule } from 'ng2-file-upload';
import { AlertYesNoDirective } from './shared/alert-yesno.directive';
import { HttpService, getHttpService } from './services/http.service';
import { RequestOptions, XHRBackend } from "@angular/http";
import { AppReloadDirective } from './app-reload/app-reload.directive';
import { IdPUserComponent } from './idpusers/add_edit_idpuser.component';
import { IdPUsersListComponent } from './idpusers/idpusers_list.component';
import { AppService } from './services/app.service';
import { IdpsComponent } from './idps/idps.component';
import { RolesMappingComponent } from './roles-mapping/roles-mapping.component';
import { DomainVerificationComponent } from './domain-verification/domain-verification.component';
import { AddEditIdPComponent } from './idps/idp-add-edit.component';
import { IdPConfigComponent } from './idps/idp-config.component';
import { IdPUserRolesListComponent } from './idpuser-roles/idpuser_roles.component';
import { IdPUserRoleComponent } from './idpuser-roles/add_update_idpuser_roles.component';
import { IdPEndpointsComponent } from './idps/idp-endpoints.component';
import { UserManagementComponent } from './user_management.component';
import { AddEditAttributeComponent } from './idps/attribute-add-edit.component';
import { AddIdPDomainComponent } from './domain-verification/add-domain.component';
import { AddEditRolesMappingComponent } from './roles-mapping/add-edit-roles-mapping.component';
import { IdentityAccessComponent } from './identity_access.component';

@NgModule({
	declarations: [
		AppComponent,
		DashboardComponent,
		FooterComponent,
		LoginComponent,
		AlertDirective,
		OffClickDirective,
		CatchAllComponent,
		TruncatePipe,
		AppToggleComponent,
		AlertYesNoDirective,
		AppReloadDirective,
		IdPUserComponent,
		IdPUsersListComponent,
		IdpsComponent,
		RolesMappingComponent,
		DomainVerificationComponent,
		AddEditIdPComponent,
		IdPConfigComponent,
		IdPUserRolesListComponent,
		IdPUserRoleComponent,
		IdPEndpointsComponent,
		UserManagementComponent,
		AddEditAttributeComponent,
		AddIdPDomainComponent,
		AddEditRolesMappingComponent,
		IdentityAccessComponent,
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpModule,
		routing,
		ReactiveFormsModule,
		Angulartics2Module.forRoot(),
		FileUploadModule
	],
	providers: [
		AppTitle,
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: Account, useFactory: accountServiceFactory, deps: [Config, Http] },
		{ provide: IdentityService, useFactory: IdentityServiceFactory, deps: [HttpService, Account, Config] },
		{ provide: Config, useFactory: loadConfig },
		{ provide: HttpService, useFactory: getHttpService, deps: [XHRBackend, RequestOptions, Injector] },
		Auth,
		AppService,
	],
	bootstrap: [AppComponent]
})

export class AppModule { }
